import React from 'react'

export default function LoaderBlock({ type, showTitle, title, titleClasses, textAlign = "center", wrapperClasses }) {

  let content = '';

  switch (type) {
    case "5-col":
      content = (
        <div className="grid--5 grid--xl-4 grid--l-3 grid--m-2 grid--s-1 gap--s">
          <div className="card loading"></div>
          <div className="card loading"></div>
          <div className="card loading"></div>
          <div className="card loading"></div>
          <div className="card loading"></div>
        </div>
      )
      break;
    case "3-col":
      content = (
        <div className="grid--3 grid--m-1 gap--s">
          <div className="card loading"></div>
          <div className="card loading"></div>
          <div className="card loading"></div>
        </div>
      )
      break;
    case "2-col":
    case "countdowns":
      content = (<div className="loading-countdown-card-wrap">
          <div className="card loading"></div>
          <div className="card loading"></div>
        </div>
      )
      break;
    case "collection":
      content = (
        <div data-collection-id="fluf-world" className="loading-collection grid--auto-2-3 gap--xl">
          <div className="col-1 owl--l">
            <div className="card loading">
              <div style={{paddingBottom: "200px"}}></div>
            </div>
            <div className="card loading">
              <div style={{paddingBottom: "100px"}}></div>
            </div>
            <div className="card loading">
              <div style={{paddingBottom: "100px"}}></div>
            </div>
          </div>
          <div className="col-2 text--left owl--m">
            <div className="owl--m">
              <div className="card" style={{paddingBottom: "400px"}}></div>
            </div>
          </div>
        </div>
      )
      break;

    case "collection-alt":
      content = (
        <div data-collection-id="fluf-world" className="loading-collection-alt grid--3-2 grid--l-1 gap--l">
          <div className="col-2 text--left owl--m">
            <div className="owl--m">
              <div className="card loading" style={{paddingBottom: "150px"}}></div>
            </div>
          </div>
          <div className="col-1 owl--l">
            <div className="card loading">
              <div style={{paddingBottom: "30px"}}></div>
            </div>
            <div className="card loading">
              <div style={{paddingBottom: "30px"}}></div>
            </div>
            <div className="card loading">
              <div style={{paddingBottom: "30px"}}></div>
            </div>
          </div>          
        </div>
      )
      break;
    case "hero":
      content = (
        <section className="loader-hero page-width grid--l-1 grid--2" style={{paddingTop: "clamp(7.2rem,calc(5vw + 5.6rem),12rem)", paddingBottom: "clamp(7.2rem,calc(5vw + 5.6rem),12rem)"}}>
          <div className="title-wrap">
            <div className="loading"></div>
          </div>
          <div className="image-wrap">
            <div className="loading">
              <div style={{paddingBottom: "400px"}}></div>
            </div>
          </div>
        </section>
      )
      break;
    default:
      content = (
        <div className="grid--3 grid--m-1 gap--s">
          <div className="card loading"></div>
          <div className="card loading"></div>
          <div className="card loading"></div>
        </div>
      )
      break;
  }

  return (
    <div className={wrapperClasses} style={{textAlign: textAlign}}>
      { showTitle && <div className={titleClasses}>{title}</div> }
        { content }
    </div>
  )
}
